declare var require: any;
import './grid-list.template.html';
import { gridListController } from './grid-list.controller'

export var gridListComponent = {
    template: require('./grid-list.template.html'),
    controller: gridListController,
    bindings: {
        id: '@',
        apiUrl: '@',
        apiMethod: '@',
        apiData: '@',
        apiType: '@',
        showPrice: '@',
        pagination: '@',
        pageSize: '@',
        newTab: '@'
    }
}


// WEBPACK FOOTER //
// ./src/components/grid-list/grid-list.ts